import Layout from "src/layout";
import styled, { css } from "styled-components";
import { useBoundStore } from "src/store";
import { ReactNode, useEffect, useRef, useState } from "react";
import { theme } from "src/styles/theme";
import ReviewQcastStudio from "./ReviewQCastStudio";
import Loader from "src/components/Loader";
import useRecorder from "src/hooks/useRecorder";
import { isBlob, isValidBlob } from "src/shared/utils/helper";

const RespondContainer = styled.div<{snapshot?: string}>`
    width: 100%;
    height: 100%;
    // height: 100vh;
    // background-color: #1a1a21;
    color: white;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    // background: linear-gradient(0deg, rgba(220, 214, 215, 0.48), rgba(0, 0, 0, 0.48)), linear-gradient(0deg, rgba(60, 61, 69, 0.16), rgba(19, 42, 131, 0.16));
    background: #E9E7E9;
    background-image: ${({ snapshot }) => `url(${snapshot})`};
    background-size: cover;
    background-position: center;
    position: relative;
    backdrop-filter: blur(120px)

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1); /* Transparent overlay */
        backdrop-filter: blur(15px); /* Glass effect */
        -webkit-backdrop-filter: blur(15px);
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
`;

const Edit = () => {
    const [videos, setVideos] = useState<{
        index: number;
        video: any;
        duration?: number;
        editedBlob?: any;
        transcriptionText?: string;}[]>([])
    const { globalSettings, activityLoader, questions,  thumbnails, recordedVideo, saveQcastResponse, loadVideo, videoTranscription } = useBoundStore();
    const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);

    const [qstnList, setQstnList] = useState<any[]>([]);

    const [snapshot, setSnapshot] = useState<string | null>(null);

  
    
    
   
    
    const handleVideoNavigation = (index: number) => {
        setCurrentVideoIndex(prev=>prev + index);
    }

    const handleSnapshot =(imageData: string) => {
        setSnapshot(imageData)
    }

    const getBlobFromDB=async(videoBlobId: string)=>{
        const blob: any = await loadVideo(videoBlobId);
        if (blob) {
          return blob.video;
        }
        return {};
    }
    
    const processQuestions = () => {
        const videoQstn: any = questions?.listOfVideos instanceof Array && questions?.listOfVideos.map((video, index)=>{
          return {
            url: video,
            question: questions.title,
            comment: 0,
            maxDuration: questions.listOfResponsesLimits[index]
          }
        })
        setQstnList(videoQstn);
    }
      
      
    useEffect(() => {
    
        if (recordedVideo.length > 0) {
            (async () => {
                const updatedVideos: any = await Promise.all(
                    recordedVideo.map(async (video) => {
                        const blob = isBlob(video.editedBlob) && isValidBlob(video.editedBlob)
                            ? await getBlobFromDB(`${video.index}-edited`)
                            : await getBlobFromDB(`${video.index}`);
                        
                        // if (!blob) {
                        //     console.error(`No blob found for index ${video.index}`);
                        //     return { url: "", title: "" }; // Handle missing blob gracefully
                        // }
    
                        return {
                            ...video,
                            video: blob
                        };
                    })
                );
                setVideos(updatedVideos);
            })();
        }
    }, [recordedVideo]);
    
    
    useEffect(()=>{
        if(questions){
          processQuestions();
        }
    }, [questions])
console.log(recordedVideo)
    return (
        <Layout>
            {activityLoader && <Loader />}
            <RespondContainer snapshot={snapshot}>
                <ReviewQcastStudio thumbnails={thumbnails} qcast={questions} transcriptions={videoTranscription}  questions={qstnList} videos={videos} onPublish={saveQcastResponse} />
            </RespondContainer>
        </Layout>
    )
}

export default Edit;